const clippingOverflow = /^(auto|scroll|hidden|clip)$/u;

export const isFocusedEmbedVisible = (container: HTMLElement | undefined): boolean => {
	const frame = container?.ownerDocument.activeElement;
	const win = container?.ownerDocument.defaultView;
	if (!frame || !win || frame.tagName !== 'IFRAME' || !container?.contains(frame)) {
		return false;
	}

	const rect = frame.getBoundingClientRect();
	let visibleLeft = Math.max(rect.left, 0);
	let visibleTop = Math.max(rect.top, 0);
	let visibleRight = Math.min(rect.right, win.innerWidth);
	let visibleBottom = Math.min(rect.bottom, win.innerHeight);
	if (visibleLeft >= visibleRight || visibleTop >= visibleBottom) {
		return false;
	}

	// Tall apps cannot fit entirely onscreen. Preserve editing while any shared visible area remains.
	for (let parent = frame.parentElement; parent; parent = parent.parentElement) {
		const style = win.getComputedStyle(parent);
		const clipsX = clippingOverflow.test(style.overflowX);
		const clipsY = clippingOverflow.test(style.overflowY);
		if (!clipsX && !clipsY) {
			continue;
		}
		const bounds = parent.getBoundingClientRect();
		const scaleX = parent.offsetWidth ? bounds.width / parent.offsetWidth : 1;
		const scaleY = parent.offsetHeight ? bounds.height / parent.offsetHeight : 1;
		const left = bounds.left + parent.clientLeft * scaleX;
		const top = bounds.top + parent.clientTop * scaleY;
		if (clipsX) {
			visibleLeft = Math.max(visibleLeft, left);
			visibleRight = Math.min(visibleRight, left + parent.clientWidth * scaleX);
		}
		if (clipsY) {
			visibleTop = Math.max(visibleTop, top);
			visibleBottom = Math.min(visibleBottom, top + parent.clientHeight * scaleY);
		}
		if (visibleLeft >= visibleRight || visibleTop >= visibleBottom) {
			return false;
		}
	}
	return true;
};
